import React from 'react';

import styles from './GreyBox.scss';
import { PageTitle, Steps, Tabs, GreyBoxMessage, Flex, FlexColumn, ActionsNav, Icon } from 'components'


const GreyBox = (props) => {
  var titleString = '';
  let classNames = styles.wrapper;
  let stepsString = '';
  let tabsString = '';

  if(props.steps){
    stepsString = <Steps val={props.steps} />
  }



  if(props.title){
  	titleString = <PageTitle theme={props.titleTheme}>{props.title}</PageTitle>
  }

  let headerWidth = props.closeIcon ? '10*9' : '1'
  let headerString = <Flex>
                        <FlexColumn col={headerWidth}>
                          {titleString}
                        </FlexColumn>
                        {props.closeIcon ? 
                        <FlexColumn col="10*1">
                          <ActionsNav>
                            <a onClick={props.closeIcon}><Icon type="image" content="close" size="16px"/></a>
                          </ActionsNav>
                        </FlexColumn>
                        : ' '}
                      </Flex>


  var messageString = '';
  var insideMessageString = '';
  var extraStyles = { 
                      backgroundColor: '',
                      border: "none"
                    };
  if(props.msg){
    messageString = <GreyBoxMessage type={props.msg.type}>{props.msg.message}</GreyBoxMessage>
  }

  if(props.msg_inside){
    insideMessageString = <GreyBoxMessage type={props.msg_inside.type} position="inside">{props.msg_inside.message}</GreyBoxMessage>
  }

  if(props.type=="fullWidth"){
    classNames = classNames + ' ' + styles.fullWidth;
  }

  if(props.outerMargin){
    classNames = classNames + ' ' + styles.outerMargin;
  }

  if(props.smallMargin){
    classNames = classNames + ' ' + styles.isSmallMargin;
  }

  if(props.bgColor){
    extraStyles.backgroundColor = props.bgColor;
  }

  if(props.borderColor){
    extraStyles.border = "1px solid "+props.borderColor;
  }

  if(props.valign=="center"){
    classNames = classNames + ' ' + styles.isCenter;
  }

  if(props.cols=="2"){
    classNames = classNames + ' ' + styles.col2;
  }

  if(props.noPrint){
    classNames = classNames + ' ' + styles.noPrint
  }

  if(props.tabs){
    tabsString = <Tabs val={props.tabs} onTabClicked={props.onTabClicked} theme={props.titleTheme}/>
  }

  return (
		<div className={classNames}>
			{headerString}
      {stepsString}
      {messageString}
      {tabsString}
			<div className={styles.greybox} style={extraStyles}>
              {insideMessageString}
	            {props.children}
			</div>
	  </div>
	)
}


export default GreyBox


// WEBPACK FOOTER //
// ./src/components/organisms/GreyBox/index.js